import Utils from "@/commons/Utils";

export default {

  getEnumAnexoEntidade(entidade = ""){
    return Utils.clone(entidade).toUpperCase().replaceAll("-", "_");
  }

}
